import { Suspense, useEffect, useMemo } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import { FlatRoutingConfiguration } from '@app/config/routing.config';
import { ConfigurationService } from '@app/core/configuration/configuration.service';
import { Logger } from '@app/core/logger/logger';
import { LoginController } from '@app/feature/login/login.controller';
import { AuthenticatedController } from '@app/router/authenticated.controller';
import { DefaultController } from '@app/router/default.controller';
import { generateRouterFromConfiguration } from '@app/router/generate-router-from-configuration';
import { MustResetPasswordGuard } from '@app/router/must-reset-password.guard';

import { APP_PATH } from 'src/config/app-paths';
import { BaseLayout } from 'src/shared/layout/base-layout';

export const Router = (): React.JSX.Element => {
  const location = useLocation();

  useEffect(() => {
    if (!ConfigurationService.isProduction()) {
      Logger.debug(location);
    }
  }, [location]);

  const routing = useMemo(
    () => generateRouterFromConfiguration(FlatRoutingConfiguration),
    [],
  );

  return (
    <Suspense>
      <Routes>
        {/* Guest area */}
        <Route path={APP_PATH.LOGIN} element={<LoginController />} />

        {/* Authenticated area */}
        <Route element={<AuthenticatedController />}>
          <Route element={<MustResetPasswordGuard />}>
            <Route element={<BaseLayout />}>{routing}</Route>
          </Route>
        </Route>

        {/* Default route  */}
        <Route path="*" element={<DefaultController />} />
      </Routes>
    </Suspense>
  );
};
